import * as React from 'react';
import { canUseSymbol } from "../../utilities/index.js";
import { global, invariant } from "../../utilities/globals/index.js";
var contextKey = canUseSymbol
    ? Symbol.for('__APOLLO_CONTEXT__')
    : '__APOLLO_CONTEXT__';
export function getApolloContext() {
    invariant('createContext' in React, 44);
    var contextStorage = global[contextKey] || (global[contextKey] = Object.create(null));
    return contextStorage[React.version] || (contextStorage[React.version] = Object.assign(React.createContext({}), { displayName: 'ApolloContext' }));
}
export var resetApolloContext = getApolloContext;
//# sourceMappingURL=ApolloContext.js.map